import { render, staticRenderFns } from "./talentFormItem.vue?vue&type=template&id=3641b28c&scoped=true"
import script from "./talentFormItem.vue?vue&type=script&lang=js"
export * from "./talentFormItem.vue?vue&type=script&lang=js"
import style0 from "./talentFormItem.vue?vue&type=style&index=0&id=3641b28c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3641b28c",
  null
  
)

export default component.exports